<!-- footer start-->
<div class="container-fluid">
  <div class="row">
    <div class="col-md-12 footer-copyright text-center">
      <p class="mb-0">Clínica Oftalmologica de Alta Complejidad SA © Copyright {{ today | date:'y'}} </p>
    </div>
    <!-- <div class="col-md-12 footer-copyright text-center">
      <p class="mb-0">Powered Castillo Solutions </p>
    </div> -->
  </div>
</div>